import React from 'react';
import Hero from '../../components/Hero/Hero';
import './HeroSection.css';

export default function HeroSection() {
  return (
    <div className="hero-section-wrapper">
      <Hero />
    </div>
  );
}
